export default "__VITE_ASSET__q7C5zopZ__"